// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1kS2a","resendInfoText":"OnGoingPaymentBox_resendInfoText__36S4M"};